import { observer } from 'mobx-react';
import Loader from '../../../../../Loader';
import LearningCollectionEditStore from '../../Store';
import { EditingDetails, SavingDetails } from '../../Store/Types';
import Form from './Form';
import { UploadImageStore } from './UploadImageStore';

interface Props {
  store: LearningCollectionEditStore;
  state: EditingDetails | SavingDetails;
  uploadImageStore: UploadImageStore;
}

function Display({ store, state, uploadImageStore }: Props) {
  switch (state.kind) {
    case 'editing-details':
      return <Form store={store} uploadImageStore={uploadImageStore} />;
    case 'saving-details':
      return <Loader />;
  }
}
export default observer(Display);
